import type { Transition } from "@uirouter/react";

import { ActivationComponentAssets } from "app/pages/activation/helpers/ActivationAssets";
import { onRedirectToActivation } from "app/pages/activation/routing/redirectHooks/onRedirectToActivation";

export const onRedirectToAllowedActivation = () => {
    return async (transition: Transition) => {
        const hasActivation = ActivationComponentAssets.isAllowed;

        return hasActivation ? onRedirectToActivation()(transition) : undefined;
    };
};
